import React from 'react'

import { Display, Box } from '@gousto-internal/citrus-react'
import { Form, FormikProvider } from 'formik'
import { useSelector } from 'react-redux'

import { PaymentProps } from 'routes/Checkout/Steps/Payment/Payment'
import { getDeliveryAddress } from 'routes/Checkout/checkoutSelectors'

import { ErrorMessage } from '../ErrorMessage/ErrorMessage'
import { SubmitButton } from '../SubmitButton'
import { CheckoutBillingAddress } from './CheckoutBillingAddress'
import { CheckoutFrame } from './CheckoutFrame/CheckoutFrame'
import { useCheckoutFrame } from './CheckoutFrame/useCheckoutFrame'
import { useAddressDetailsForm } from './useAddressDetailsForm'

type CheckoutPaymentDetailsProps = Pick<
  PaymentProps,
  'checkoutScriptReady' | 'submitOrder' | 'onLoginClick'
> & {
  hide: boolean
}

export const CheckoutPaymentDetails = ({
  checkoutScriptReady,
  submitOrder,
  onLoginClick,
  hide,
}: CheckoutPaymentDetailsProps) => {
  const formik = useAddressDetailsForm()
  const deliveryAddress = useSelector(getDeliveryAddress)

  const {
    formValidationError,
    handleSubmitCard,
    isCheckoutFormSubmitting,
    isCheckoutFormValid,
    handleCardDetailsValidation,
  } = useCheckoutFrame({
    checkoutScriptReady,
    submitOrder,
  })

  const processSubmit = () => {
    formik.setFieldTouched('cardHolderName')
    if (!isCheckoutFormValid) {
      handleCardDetailsValidation()
    }
    if (isCheckoutFormValid && formik.isValid) {
      formik.submitForm()
      handleSubmitCard({ values: formik.values, deliveryAddress })
    }
  }

  return (
    <Box display={hide ? Display.None : Display.Block}>
      <FormikProvider value={formik}>
        <Form>
          <CheckoutFrame formValidationError={formValidationError} />
          <CheckoutBillingAddress />
          <ErrorMessage onLoginClick={onLoginClick} />
          <SubmitButton onClick={processSubmit} isDisabled={isCheckoutFormSubmitting} />
        </Form>
      </FormikProvider>
    </Box>
  )
}
